"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var GALLERY_TEXT_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center'
};
var _default = GALLERY_TEXT_ALIGN;
exports["default"] = _default;